import { render, staticRenderFns } from "./v-layout.vue?vue&type=template&id=651122bf&scoped=true&"
import script from "./v-layout.vue?vue&type=script&lang=js&"
export * from "./v-layout.vue?vue&type=script&lang=js&"
import style0 from "./v-layout.vue?vue&type=style&index=0&id=651122bf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651122bf",
  null
  
)

export default component.exports